<template>
  <div class="ar-main">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ArMain',

  componentName: 'ArMain'
  
};
</script>


// WEBPACK FOOTER //
// src/components/anyUI/main/main.vue